<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form (ngSubmit)="query['offset'] = 0; loadDescriptions()">
      <div class="filter-form__header sticky">
        <button class="button float-left" nz-button nzType="secondary" type="button" (click)="emptyFilter()">
          {{ 'core.btn.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" [disabled]="loading" type="submit">
          {{ 'core.btn.search' | translate }}
        </button>
      </div>

      <div class="filter-form__body">
        <hw-panel-form-item class="date-picker-group" label="mdm.snomed-02.label.created-from">
          <hw-date-time-picker
            name="createdFrom"
            [(ngModel)]="query.createdFrom"
            defaultTime="00:00"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item class="date-picker-group" label="mdm.snomed-02.label.created-to">
          <hw-date-time-picker name="createdTo" defaultTime="23:59" [(ngModel)]="query.createdTo"></hw-date-time-picker>
        </hw-panel-form-item>

        <hw-panel-form-item label="mdm.snomed-02.label.author">
          <hw-select name="name" [(ngModel)]="query.author" required>
            <hw-option
              *ngFor="let user of users | values"
              label="{{ user.userNames | localName }}"
              [value]="user | format : formatUserSub"></hw-option>
          </hw-select>
        </hw-panel-form-item>

        <hw-panel-form-item class="date-picker-group" label="mdm.snomed-02.label.reviewed-from">
          <hw-date-time-picker
            name="reviewedFrom"
            defaultTime="00:00"
            [(ngModel)]="query.reviewedFrom"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item class="date-picker-group" label="mdm.snomed-02.label.reviewed-to">
          <hw-date-time-picker
            name="reviewedTo"
            defaultTime="23:59"
            [(ngModel)]="query.reviewedTo"></hw-date-time-picker>
        </hw-panel-form-item>

        <hw-panel-form-item label="mdm.snomed-02.label.reviewer">
          <hw-select name="reviewer" [(ngModel)]="query.reviewer" required>
            <hw-option
              *ngFor="let user of users | values"
              label="{{ user.userNames | localName }}"
              [value]="user | format : formatUserSub"></hw-option>
          </hw-select>
        </hw-panel-form-item>

        <hw-panel-form-item label="mdm.snomed-02.label.status">
          <hw-select name="status" [(ngModel)]="query.status" required>
            <hw-option label="{{ 'mdm.snomed-02.status.draft' | translate }}" value="draft"></hw-option>
            <hw-option label="{{ 'mdm.snomed-02.status.on-review' | translate }}" value="on-review"></hw-option>
            <hw-option label="{{ 'mdm.snomed-02.status.confirmed' | translate }}" value="confirmed"></hw-option>
          </hw-select>
        </hw-panel-form-item>
      </div>
    </form>
  </div>
  <nz-content class="page-content--header-inside">
    <hw-page-header header="mdm.snomed-02.header" class="page-header">
      <div class="content float-right">
        <button (click)="exportTranslations()" class="button" nz-button nzType="secondary">
          {{ 'mdm.snomed-02.export' | translate }}
        </button>
        <button (click)="touchImportTranslationsInput()" class="button" nz-button nzType="secondary">
          {{ 'mdm.snomed-02.import' | translate }}
        </button>
        <a nz-dropdown [nzDropdownMenu]="dropdownMenu" [nzPlacement]="'bottomRight'">
          <button class="button" title="More" type="button" nz-button nzType="icon" nz-dropdown>
            <i class="material-icons">more_horiz</i>
          </button>
        </a>
        <nz-dropdown-menu #dropdownMenu>
          <ul nz-menu>
            <li nz-menu-item>
              <a (click)="exportToRF2()">{{ 'mdm.snomed-02.export-rf2' | translate }}</a>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </hw-page-header>
    <div class="page-content__flex-cols-container">
      <hw-backend-table
        nz-col
        nzSpan="24"
        *ngIf="decoratedDescriptions"
        [query]="query"
        (dataChange)="loadDescriptions()"
        [result]="descriptions"
        [loading]="loading">
        <hw-backend-column title="mdm.snomed-02.title.code">
          <ng-template #cellTemplate let-description>
            <a [routerLink]="['/snomed/view', description.conceptId]">{{ description.conceptId }}</a>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="mdm.snomed-02.title.snomed-translations">
          <ng-template #cellTemplate let-description>
            <div style="display: grid">
              <span *ngFor="let d of decoratedDescriptions[description.conceptId][0]['snomedTranslations']"
                >{{ d.lang }} {{ d.term }}</span
              >
            </div>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="mdm.snomed-02.title.heda-translations">
          <ng-template #cellTemplate let-description>
            <div style="display: grid">
              <span *ngFor="let d of decoratedDescriptions[description.conceptId]">
                <b *ngIf="d.id === description.id">{{ d.lang }} {{ d.term }}</b>
                <label *ngIf="d.id !== description.id">{{ d.lang }} {{ d.term }}</label>
                <nz-tag [nzColor]="'blue'" *ngIf="d.status === 'draft'"> {{ d.status }}</nz-tag>
                <nz-tag [nzColor]="'orange'" *ngIf="d.status === 'on-review'"> {{ d.status }}</nz-tag>
                <nz-tag [nzColor]="'green'" *ngIf="d.status === 'confirmed'"> {{ d.status }}</nz-tag>
              </span>
            </div>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="mdm.snomed-02.title.author">
          <ng-template #cellTemplate let-description>
            <div style="display: grid">
              <span>{{ description.author }}</span>
              <span>{{ description.created | localDateTime }}</span>
            </div>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="mdm.snomed-02.title.reviewer">
          <ng-template #cellTemplate let-description>
            <div style="display: grid">
              <span>{{ description.reviewer }}</span>
              <span>{{ description.reviewed | localDateTime }}</span>
            </div>
          </ng-template>
        </hw-backend-column>
      </hw-backend-table>
    </div>
    <input #importTranslations [hidden]="true" type="file" (change)="importTranslationsFromFile($event)" />
  </nz-content>
</div>
